import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { GridColumn, GridRow } from 'src/components/Reusable/Grid'
import { FlexRow } from 'src/components/Reusable/Flex'

export const PolicyGridColumn = styled(GridColumn)`
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
`

export const SpinnerContainer = styled.div`
  width: 100%;
  padding-left: 1.5em;
`

export const ControlGridRow = styled(GridRow)<{
  $isNotApplicable?: boolean
  $isPurple?: boolean
}>`
  ${({ $isPurple }) =>
    $isPurple &&
    `
    > .grid-column {
      background-color: ${palette.purple['30']};
    }
    &:hover {
      > .grid-column {
        background-color: ${palette.purple['50']};
      }
    }
  `}
  ${({ $isNotApplicable }) =>
    $isNotApplicable &&
    `
    > .grid-column {
      background-color: ${palette.neutral['50']};
    }
    &:hover {
      > .grid-column {
        background-color: ${palette.neutral['100']};
      }
    }
  `}
`

export const ControlCheckResultPillsContainer = styled(FlexRow)`
  gap: 8px;
  padding: 0 8px;
`
